import { Component, Inject, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { Button } from 'primeng/button';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { Pagination } from '@app/shared/model';
import { TableComponent, TableColumn } from '@app/shared/components/table/table.component';
import { MenuItem, MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { FormBuilder, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { FilterItem } from '@app/features-modules/gestao-bolseiros/components/api/models';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { forkJoin } from 'rxjs';
import { EnumService } from '@app/features-modules/gestao-bolseiros/components/api/services';
import { DatePicker } from 'primeng/datepicker';
import { InputText } from 'primeng/inputtext';
import { LogsBolseirosService } from '../../../api/services/logs-bolseiros.service';
import { JsonTreeComponent } from '@app/shared/components/json-tree/json-tree.component';
import { format } from 'date-fns';

@Component({
  selector: 'app-logs-bolseiros',
  imports: [
    CommonModule,
    SelectModule,
    Button,
    DataVoidComponent,
    TableComponent,
    InputText,
    Toast,
    ReactiveFormsModule,
    DialogModule,
    SearchBarComponent,
    DatePicker,
    JsonTreeComponent
  ],
  providers: [
    LogsBolseirosService,
    MessageService
  ],
  templateUrl: './logs-bolseiros.component.html',
  styleUrl: './logs-bolseiros.component.scss'
})
export class LogsBolseirosComponent implements OnInit {
  logsBolseirosService = inject(LogsBolseirosService);
  messageService = Inject(MessageService);
  enumService = inject(EnumService);
  fb = inject(FormBuilder);
  showFilter: boolean = false;
  showDetalhe: boolean = false;
  form!: FormGroup;
  formLog!: FormGroup;
  listAtivitys: any[] = [];
  listEntidades: any[] = [];
  logsCount: any;
  registo: any;
  jsonLog: any;
  pagination: Pagination<any> = new Pagination<any>().deserialize({
    data: [],
    totalRecords: 0,
    pageNumber: 1,
    pageSize: 10,
  });

  execucaoList = [
    { label: 'Sucesso', value: true },
    { label: 'Falha', value: false }
  ]
  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'user',
      placeholder: 'Utilizador',
    },
    {
      type: 'dropdown',
      controlName: 'AcaoEnum',
      placeholder: 'Acção realizada',
      options: this.listAtivitys,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'execucao',
      placeholder: 'Execução',
      options: this.execucaoList,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EntidadeEnum',
      placeholder: 'Entidade',
      options: this.listEntidades,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'date',
      controlName: 'date',
      placeholder: 'Data & Hora',
      optionLabel: 'label',
      optionValue: 'value',
    },
  ];

  columns: TableColumn[] = [
    { field: 'nome', header: 'Utilizador', tooltip: 'Utilizador', type: 'text' },
    { field: 'acao', header: 'Acção', tooltip: 'Acção', type: 'text' },
    {
      field: 'sucesso',
      header: 'Execução',
      type: 'tag',
      formatter: (value: boolean) => (value ? 'Sucesso' : 'Falha'),
      tagSeverityFunction: (row: any) => (row.sucesso ? 'success' : 'danger'),
    },
    { field: 'data', header: 'Data', tooltip: 'Data', type: 'text' ,  formatter: (value: string) =>
      format(new Date(value), 'dd/MM/yyyy HH:mm')},
  ];

  actions: MenuItem[] = [
    {
      label: 'Detalhe',
      icon: 'pi pi-info-circle',
      command: ($event: any) => this.getDetalhe($event.item.data),
    }
  ];

  ngOnInit(): void {
    this.loadLogs();
    this.loadDropdowns();

    this.form = this.fb.group({
      user: [null],
      AcaoEnum: [null],
      execucao: [null],
      EntidadeEnum: [null],
      date: [null],
    });

    this.formLog = this.fb.group({
      nome: [{ value: '', disabled: true }],
      email: [{ value: '', disabled: true }],
      dataFormata: [{ value: '', disabled: true }],
      acao: [{ value: '', disabled: true }],
      sucesso: [{ value: '', disabled: true }],
    });
  }

  loadLogs(filters?: any) {
    const params = {
      ...filters,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      orderBy: filters?.orderBy || 'id desc',
    };

    this.logsBolseirosService.list(params).subscribe({
      next: (result: any) => {
        this.pagination = new Pagination<any>().deserialize(result);
        this.logsCount = this.pagination?.totalRecords;
      },
      error: (error: any) => {
        console.error('Erro ao buscar registos:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar registos.',
        });
      },
      complete: () => {
      },
    });
  }

  getDetalhe(log: any) {
    this.registo = log;
    this.formLog.patchValue({
      nome: this.registo?.nome,
      email: this.registo?.email,
      dataFormata: this.registo?.dataFormata,
      acao: this.registo?.acao,
      sucesso: this.registo?.sucesso ? "Sucesso" : "Falha",
    })
    this.logsBolseirosService.show(this.registo?.id).subscribe({
      next: (result: any) => {
        this.jsonLog = result;
      },
      error: (error: any) => {
        console.error('Erro ao buscar registos:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar registos.',
        });
      }
    })
    this.showDetalhe = true;
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ''
      )
    );
    this.loadLogs(filters)
    this.showFilter = false;
  }

  loadDropdowns() {
    forkJoin({
      ativitys: this.enumService.getAllEnumAcaoAtivityLogsEnumEnum(),
      entidadesEnums: this.enumService.getAllEnumEntidadeEnum()
    }).subscribe((response) => {
      // Enums
      if (response.ativitys?.data) {
        this.listAtivitys = Object.entries(response.ativitys.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          })
        );
        this.filters[1].options = this.listAtivitys;
      }
      if (response.entidadesEnums?.data) {
        this.listEntidades = Object.entries(response.entidadesEnums.data).map(([key, value]) => ({
          id: Number(key),
          label: value,
        })
        );
        this.filters[3].options = this.listEntidades;
      }
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadLogs(event)
  }
}
